import React from 'react';
import { TooltipProvider } from '../../../components/ui/tooltip';
import UserAvatar from '../toolbar/UserAvatar';

const BottomActions: React.FC = () => {
  return (
    <TooltipProvider>
      <div className="flex flex-col gap-1 px-2 py-1 pb-2">
        {/* User Avatar */}
        <UserAvatar inSidebar />
      </div>
    </TooltipProvider>
  );
};

export default BottomActions;
